import React from 'react';
import { Card } from 'react-bootstrap';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { customStyles } from '../../../../../Components/helper';
import CustomDatePicker from '../../../../../Components/Utility/DatePicker/DatePicker';

function SinglePackUnit({ data, fromAddEdit, forSwitch, lengthEnabled }) {
  const { t } = useTranslation('common');

  return (
    <Card className="card-margin-bottom rounded-0 pb-3">
      <Card.Header className="bgcolor-dark rounded-0">
        <div className="d-flex flex-wrap align-items-center p-2">
          <div className="custom-control custom-switch">
            <input
              type="checkbox"
              className="custom-control-input"
              id="singleSwitch"
              name="singleSwitch"
              onChange={forSwitch}
              disabled={!fromAddEdit}
              checked={data?.visible?.singular}
            />
            <label className="custom-control-label" htmlFor="singleSwitch">
              <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.SINGLE_SWITCH_UNIT')}</strong>
            </label>
          </div>
          <div className="date pr-3 my-2 my-md-0 ml-md-auto">
            <div className="input-button-container bg-white">
              <CustomDatePicker
                dateFormat="dd/MM/yyyy"
                name="selectedActualApproveByDate"
                popperPlace="top-end"
                placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.HANDOVER_DATE')}
                disable
              />
            </div>
          </div>
          <div className="date justify-content-end pr-1">
            <div className="input-button-container bg-white">
              <CustomDatePicker
                dateFormat="dd/MMM/yyyy"
                name="selectedActualApproveByDate"
                popperPlace="top-end"
                placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.SHIPMENT_DATE')}
                disable
              />
            </div>
          </div>
        </div>
      </Card.Header>
      {(data?.visible?.singular || fromAddEdit) && (
        <Card.Body>
          <div className="table-responsive">
            <table className="table custom-table xs-layout-fixed font-13 mb-3">
              <thead>
                <tr>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.SIZE')}</th>
                  {lengthEnabled && <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.LENGTH')}</th>}
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.QUANTITY')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.PRICE_BEFORE_DISCOUNT')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.DISCOUNT_PERCENT')}</th>
                  <th className="w-xs-130px">{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.PRICE_AFTER_DISCOUNT')}</th>
                </tr>
              </thead>
              <tbody>
                <tr key={0}>
                  <td>
                    <div className="custom-react-select">
                      <Select
                        name="Size"
                        placeholder=""
                        getOptionLabel={(option) => `${option?.name}`}
                        getOptionValue={(option) => `${option?.name}`}
                        styles={customStyles}
                        isDisabled
                      />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" placeholder="" styles={customStyles} isDisabled maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      name="Quantity"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS._TEXTS')}
                      disabled
                      className="form-control text-bordered"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (Before Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.DISCOUNT_BEFORE')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Discount"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.DISCOUNT_PERCENT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (After Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.PRICE_AFTER')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                </tr>
                <tr key={1}>
                  <td>
                    <div className="custom-react-select">
                      <Select
                        name="Size"
                        placeholder=""
                        getOptionLabel={(option) => `${option?.name}`}
                        getOptionValue={(option) => `${option?.name}`}
                        styles={customStyles}
                        isDisabled
                      />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" placeholder="" styles={customStyles} isDisabled maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      name="Quantity"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.MULTI_TEXTS')}
                      disabled
                      className="form-control text-bordered"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (Before Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.DISCOUNT_BEFORE')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Discount"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.PERCENT_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (After Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.PRICE_AFTER_DIS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                </tr>
                <tr key={2}>
                  <td>
                    <div className="custom-react-select">
                      <Select
                        name="Size"
                        placeholder=""
                        getOptionLabel={(option) => `${option?.name}`}
                        getOptionValue={(option) => `${option?.name}`}
                        styles={customStyles}
                        isDisabled
                      />
                    </div>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <Select name="Length" placeholder="" styles={customStyles} isDisabled maxMenuHeight={129} menuPlacement="bottom" menuPosition="fixed" />
                    </td>
                  )}
                  <td>
                    <input
                      type="text"
                      name="Quantity"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.MULTI_TEXTS')}
                      disabled
                      className="form-control text-bordered"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (Before Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.BEFORE_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Discount"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.PERCENT_DISCOUNT')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      name="Price Per Unit (After Discount)"
                      placeholder={t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.PRICE_AFTER_DIS')}
                      className="form-control text-bordered"
                      disabled
                    />
                  </td>
                </tr>
                <tr key={3}>
                  <td colSpan={lengthEnabled ? 7 : 6}>
                    <strong className="d-flex align-item-center justify-content-center">
                      {t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.TOTAL')}
                    </strong>
                  </td>
                </tr>
                <tr key={4}>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.AUTO_')}</strong>
                  </td>
                  {lengthEnabled && (
                    <td>
                      <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.AUTO_')}</strong>
                    </td>
                  )}
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.AUTOS')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.AUTOS')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.AUTOFILLEDS')}</strong>
                  </td>
                  <td>
                    <strong>{t('PO_TEMPLATES.PO_DETAILS.PACK_UNITS.SINGLE_SIZE_PACK_UNITS.AUTOFILLEDS')}</strong>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Card.Body>
      )}
    </Card>
  );
}

export default SinglePackUnit;
